import { ComponentPropsWithoutRef, CSSProperties } from "react";
import styles from "./SnapSections.module.scss";
import clsx from "clsx";

type SectionProps = ComponentPropsWithoutRef<'section'> & {
    contentHeight?: string;
    disableSnap?: boolean;
    testId?: string;
}

export default function Section({
    children,
    className,
    contentHeight = '100svh',
    disableSnap = false,
    ...rest
}: SectionProps) {
    const style = {
        ...(rest.style ?? {}),
        ...({ "--content-height": contentHeight } as CSSProperties),
    };

    return (
        <section
            {...rest}
            style={style}
            className={clsx([
                className,
                styles.section,
                !disableSnap && styles.sectionSnapping
            ])}
        >
            {children}
        </section>
    )
}
